import { PillarData } from '../types/PillarData';

/**
 * Enriches a recommendation object with pillar information for saving to the database.
 *
 * DATA MODEL:
 * - RecommendationTemplate has an 'id' (template_id) and contains many 'tasks'
 * - ActionPlan.recommendation = the template ID
 * - ActionPlan relates to tasks via task definitions
 * - Frontend matches using ActionPlan.recommendation + task info
 * - Recommendations do NOT have their own 'id' field - use template_id
 */
export function enrichRecommendationWithPillarInfo(
  recommendation: any,
  pillarData: PillarData
): {
  recommendation_template_id: number;
  pillar_name: string;
  pillar_key: string;
  [key: string]: any;
} {
  if (!recommendation.recommendation_template_id) {
    console.warn(`Recommendation "${recommendation.title || recommendation.task_title}" is missing recommendation_template_id`);
  }

  return {
    ...recommendation,
    pillar_name: pillarData.name,
    pillar_key: pillarData.key,
  };
}



